import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Category } from '../../shop.component';

@Component({
  selector: 'app-category-tree',
  templateUrl: './category-tree.component.html',
  styleUrls: ['./category-tree.component.css']
})
export class CategoryTreeComponent implements OnInit {

  @Input('treeData') treeData: Array<TreeNode> = [];
  @Output('shout') s = new EventEmitter();

  draggers = [];
  droppers = [];
  constructor() {

  }

  ngOnInit() {
  }

  toggleChild(node) {
    console.log('toggle activated')
    node.showChildren = !node.showChildren;
  }

  shout(id) {
    console.log('shouting: ', id)
    this.s.emit(id)
  }

  itsADrag(ev, item) {
    console.log(ev)
    this.draggers.push(item);
    ev.dataTransfer.setData('text', this.draggers[0]); console.log('Dragging', ev.dataTransfer.getData('text'))


  }

  droppedCat(event, toId) {
    console.log('actual id?', event.target.id)
    console.log(event.dataTransfer.getData('text'), 'Parent to :', toId)
    this.shout({ question: 'parentCategories', answer: [event.dataTransfer.getData('text'), toId] })
  }
}

export class TreeNode {
  name: string;
  id: string;
  parentId: string;
  image: string;
  showChildren: boolean;
  numberOfPackages: number;
  children: TreeNode[];
  originalData: Category
}
